import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'span[app-card-indicators-value]',
  standalone: true,
  template: '<ng-content></ng-content>',
  styleUrls: ['card-indicators-value.component.scss'],
})
export class CardIndicatorsValueComponent {
  @HostBinding('class.card-indicators-value') readonly isCardIndicatorsValue = true;
}
